import React, { useState } from 'react';
import { MailCheck, AlertTriangle } from 'lucide-react';
import Modal from './Modal';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Deja verificado el correo al que se envían las cotizaciones de la
// mensualidad, sin que el cliente tenga que escribir el código que le llega.
const DialogoCorreoFacturacion = ({ cliente, cuenta, onGuardar, onCancel }) => {
  const [correo, setCorreo] = useState(cuenta?.correo_facturacion || cliente.duenio?.correo || '');
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  const guardar = async (e) => {
    e.preventDefault();
    const limpio = correo.trim().toLowerCase();
    if (!EMAIL.test(limpio)) {
      setError('Escriba un correo válido');
      return;
    }
    setError('');
    setGuardando(true);
    try {
      await onGuardar(limpio);
    } catch (err) {
      setError(err.message || 'No se pudo verificar el correo');
      setGuardando(false);
    }
  };

  return (
    <Modal
      titulo="Verificar correo de facturación"
      subtitulo={`${cliente.slug} · ${cliente.base_datos}`}
      icono={MailCheck}
      onClose={onCancel}
      bloqueado={guardando}
      pie={(
        <>
          <button type="button" onClick={onCancel} disabled={guardando} className="px-4 py-2 text-sm text-gray-700 rounded-lg hover:bg-gray-100">Cancelar</button>
          <button type="submit" form="form-correo-facturacion" disabled={guardando} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium disabled:opacity-50">
            {guardando ? 'Verificando…' : 'Marcar como verificado'}
          </button>
        </>
      )}
    >
      <form id="form-correo-facturacion" onSubmit={guardar} className="space-y-4 text-sm text-gray-700">
        <p>
          Las cotizaciones de la mensualidad se enviarán a este correo. Queda verificado al guardar:
          el cliente no tendrá que escribir el código de 6 dígitos.
        </p>
        {cuenta?.correo_verificado && (
          <p className="text-xs text-gray-500">Correo verificado actual: <strong>{cuenta.correo_facturacion}</strong></p>
        )}
        <label className="block">
          <span className="block text-xs font-medium text-gray-600 mb-1">Correo de facturación</span>
          <input
            type="email"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            autoFocus
            maxLength={191}
            className="w-full h-10 px-3 border border-gray-300 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </label>
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl p-3 flex items-start gap-2">
            <AlertTriangle size={16} className="mt-0.5 flex-shrink-0" /> <span>{error}</span>
          </div>
        )}
      </form>
    </Modal>
  );
};

export default DialogoCorreoFacturacion;
